import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions as formActions } from './../../modules/form/';
import LoadingPanel from './../../routes/components/LoadingPanel';
import ActionButton from '../../routes/components/ActionButton';

const timer = timeout => (function () {
    let finished = false;
    setTimeout(function () { finished = true; }, timeout);
    return finished;
}());

//todo: add selectors for success and failure
const FormConfirmationScreen = ({
    formName,
    redirectUrl,
    redirectAction,
    isLoadingSelector,
    isLoading,
    requestSuccessfulSelector,
    requestSuccessful,
    clearFormDataHandler,
    loadingMessage = 'Sending request, please wait..',
    successMessage = 'Successfully sent request. Your request is now being processed. Results should be visible shortly (please refresh main page in ~30 seconds).',
    failureMessage = 'Could not send request, please try again later.' }) => {
    return (
        <div className="row">
            <div className="col-xs-12">
                <div className="confirmation-screen-panel">
                    {isLoading &&
                        <div>                            
                            <span className="message">
                                <LoadingPanel useSmallLoadingPanel={true} />
                                {loadingMessage}
                            </span>
                        </div>
                    }
                    {!isLoading &&
                        <div>
                            <div>
                                {requestSuccessful &&
                                    <span className="message text-success">{successMessage}</span>
                                }
                                {!requestSuccessful &&
                                    <span className="message text-danger">{failureMessage}</span>
                                }
                            </div>

                            <div className="back-button text-center block">
                                <ActionButton className={"big"} action={e => {
                                    redirectAction(redirectUrl)
                                    if (clearFormDataHandler)
                                        clearFormDataHandler();
                                }
                                }
                                >Back</ActionButton>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

FormConfirmationScreen.propTypes = {
    formName: PropTypes.string.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    redirectAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
    isLoading: props.isLoadingSelector(state),
    requestSuccessful: props.requestSuccessfulSelector(state)
});

const mapDispatchToProps = (dispatch, props) => ({
    redirectAction: (redirectUrl) => dispatch(formActions.redirectBackAndResetFormCompleted(props.formName, redirectUrl))
});

export default connect(mapStateToProps, mapDispatchToProps)(FormConfirmationScreen)